// ═══════════════════════════════════════════════════════════════════════════════
// Weather greeting validation schemas
// ═══════════════════════════════════════════════════════════════════════════════
import { z } from 'zod';
import { WEATHER_GREETING_VARIANT_COUNT, } from '../constants/weatherGreeting.js';
const WEATHER_EMOJI_UNIVERSAL = ['☁️', '🌨️', '🌧️', '⛈️', '🌩️', '🌫️', '☔', '☂️'];
const WEATHER_EMOJI_DAYTIME_ONLY = ['☀️', '🌤️', '⛅', '🌥️', '🌦️'];
const WEATHER_EMOJI_NIGHTTIME_ONLY = ['🌙'];
const weatherGreetingHeadingEmojiSchema = z.object({
    daytime: z.enum([...WEATHER_EMOJI_UNIVERSAL, ...WEATHER_EMOJI_DAYTIME_ONLY]),
    nighttime: z.enum([...WEATHER_EMOJI_UNIVERSAL, ...WEATHER_EMOJI_NIGHTTIME_ONLY]),
});
const weatherGreetingLocalizedTextsSchema = z.object({
    'zh-Hant': z.string().min(1),
    'zh-Hans': z.string().min(1),
    en: z.string().min(1),
    id: z.string().min(1),
    fil: z.string().min(1),
});
export const weatherGreetingVariantSchema = z.object({
    helper: weatherGreetingLocalizedTextsSchema,
    employer: weatherGreetingLocalizedTextsSchema,
});
export const weatherGreetingGeminiOutputSchema = z.object({
    weatherEmoji: weatherGreetingHeadingEmojiSchema,
    variants: z.array(weatherGreetingVariantSchema).length(WEATHER_GREETING_VARIANT_COUNT),
});
export const weatherGreetingCurrentResponseSchema = z.object({
    visible: z.boolean(),
    text: z.string().nullable(),
    weatherEmoji: z.string().nullable(),
});
//# sourceMappingURL=weatherGreeting.schema.js.map